module.exports = __webpack_public_path__ + "static/img/banner.658dd64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_0/banner.jpg
// module id = 6oAe
// module chunks = 0